import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { trackEvent } from 'shared/helpers/Analytics';
import { ContentProgressIndicator } from 'shared/layout/ContentProgressIndicator';

const REDIRECT_DELAY_MS = 100;

const AIRBRIDGE_LINKS: Record<string, string> = {
  management:
    'https://abr.ge/@superdispatch/supercard?og_tag_id=458622489&routing_short_id=anboyb&tracking_template_id=24dc7812cb588e08e8663b253fc14f08&ad_type=click',
  fuel_finder:
    'https://abr.ge/@superdispatch/supercard?og_tag_id=458620888&routing_short_id=2rywd2&tracking_template_id=1cfb731a3be3669d520826e7ff0ba5b3&ad_type=click',
  more: 'https://abr.ge/@superdispatch/supercard?og_tag_id=459439494&routing_short_id=2pw2bj&tracking_template_id=84c35befd4493d8162d2db66af5b37a7&ad_type=click',
};

export function GoRedirectPage() {
  const { tab = '' } = useParams<{ tab: string }>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const targetUrl = AIRBRIDGE_LINKS[tab];
    if (!targetUrl) {
      return;
    }

    const utmParams: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      utmParams[key] = value;
    });

    const url = new URL(targetUrl);
    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });

    trackEvent('CTMS: Clicked Email CTA', {
      tab,
      ...utmParams,
    });
    const timeoutId = setTimeout(() => {
      window.location.href = url.toString();
    }, REDIRECT_DELAY_MS);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [tab, searchParams]);

  if (!AIRBRIDGE_LINKS[tab]) {
    return (
      <div style={{ textAlign: 'center', padding: '48px' }}>
        <h1>Link not found</h1>
        <p>
          The link <code>/go/supercard/{tab}</code> does not exist.
        </p>
      </div>
    );
  }

  return <ContentProgressIndicator />;
}
